import { Dispatch } from 'redux'
import { hasSeattleData } from 'util/server/seattle'

type SetSeattleStatusDispatcher = Dispatch<{
  type: 'SET_SEATTLE_DRIVER_STATUS'
  data: boolean
}>

export function getSeattleDriverStatus(profileId: string) {
  return async (dispatch: SetSeattleStatusDispatcher) => {
    const isSeattleDriver = await hasSeattleData(profileId)
    dispatch({ type: 'SET_SEATTLE_DRIVER_STATUS', data: isSeattleDriver })
  }
}
